"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringSeparator = void 0;
var StringSeparator;
(function (StringSeparator) {
    StringSeparator["Comma"] = ",";
    StringSeparator["Dot"] = ".";
    StringSeparator["VerticalLine"] = "|";
})(StringSeparator = exports.StringSeparator || (exports.StringSeparator = {}));
